import React, { FC, useCallback } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Gravatar from 'react-gravatar';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import UserMenu from 'components/UserMenu';

import { UserArea_user$key } from '__generated__/UserArea_user.graphql';

type Props = {
  user: UserArea_user$key;
};

const UserArea: FC<Props> = ({ user }) => {
  const { email } = useFragment(
    graphql`
      fragment UserArea_user on User {
        email
      }
    `,
    user
  );

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Avatar>
          <Gravatar email={email} default={'robohash' as any} />
        </Avatar>
      </IconButton>

      <UserMenu anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
};

export default UserArea;
